/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('DOMContentLoaded', function () {
  function getElements() {
    return {
      taxIdInput: document.querySelector(
        '.tax-id-field input[type="text"], .tax-id-field input:not([type])'
      ),

      termsCheckbox: document.querySelector(
        '.cart-policy-consent input[type="checkbox"]'
      ),

      checkoutButtons: document.querySelectorAll(
        'button[name="checkout"], input[name="checkout"]'
      )
    };
  }

  function requirementsCompleted() {
    const elements = getElements();

    if (!elements.taxIdInput || !elements.termsCheckbox) {
      return false;
    }

    const taxIdEntered =
      elements.taxIdInput.value.trim() !== '';

    const termsAccepted =
      elements.termsCheckbox.checked === true;

    return taxIdEntered && termsAccepted;
  }

  function updateCheckoutButton() {
    const elements = getElements();
    const allowed = requirementsCompleted();

    elements.checkoutButtons.forEach(function (button) {
      button.disabled = !allowed;
      button.setAttribute('aria-disabled', String(!allowed));

      if (allowed) {
        button.style.opacity = '1';
        button.style.cursor = 'pointer';
        button.style.pointerEvents = 'auto';
      } else {
        button.style.opacity = '0.5';
        button.style.cursor = 'not-allowed';
        button.style.pointerEvents = 'none';
      }
    });
  }

  document.addEventListener('input', function (event) {
    if (event.target.closest('.tax-id-field')) {
      updateCheckoutButton();
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest('.cart-policy-consent')) {
      updateCheckoutButton();
    }
  });

  document.addEventListener(
    'submit',
    function (event) {
      const checkoutButton = event.target.querySelector(
        '[name="checkout"]'
      );

      if (!checkoutButton) return;

      if (!requirementsCompleted()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const elements = getElements();

        const taxIdEntered =
          elements.taxIdInput &&
          elements.taxIdInput.value.trim() !== '';

        const termsAccepted =
          elements.termsCheckbox &&
          elements.termsCheckbox.checked;

        if (!taxIdEntered && !termsAccepted) {
          alert(
            'Please enter your Company Tax ID and agree to the Terms and Conditions.'
          );
        } else if (!taxIdEntered) {
          alert('Please enter your Company Tax ID.');
        } else {
          alert('Please agree to the Terms and Conditions.');
        }

        return false;
      }
    },
    true
  );

  // برای زمانی که تم Warehouse سبد خرید را با Ajax دوباره می‌سازد
  const observer = new MutationObserver(function () {
    updateCheckoutButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  updateCheckoutButton();
});

document.addEventListener(
  'click',
  function (event) {
    const termsLink = event.target.closest(
      'a[href*="online_store_terms_and_conditions.pdf"]'
    );

    if (!termsLink) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    window.open(termsLink.href, '_blank', 'noopener');
  },
  true
);